export default "__VITE_ASSET__e2010272__"